import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright © Universally Thinking 2026</p>
    </footer>
  );
};

export default Footer;
